import { taggedTemplateLiteral as _taggedTemplateLiteral } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import styled from 'styled-components';
import { jsxs, jsx } from 'react/jsx-runtime';

var _templateObject;
const SvgComponent = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/jsxs("svg", {
    stroke: "currentColor",
    fill: "currentColor",
    strokeWidth: 0,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56.693 56.693",
    width: "1em",
    height: "1em",
    "aria-labelledby": titleId,
    ...props,
    children: [title ? /*#__PURE__*/jsx("title", {
      id: titleId,
      children: title
    }) : null, /*#__PURE__*/jsx("path", {
      d: "M54.082 15.55a20.14 20.14 0 01-5.805 1.59 10.13 10.13 0 004.444-5.591 20.231 20.231 0 01-6.418 2.454 10.093 10.093 0 00-7.377-3.192c-5.581 0-10.107 4.525-10.107 10.107 0 .792.09 1.563.262 2.302-8.4-.42-15.848-4.444-20.832-10.56a10.058 10.058 0 00-1.369 5.082c0 3.506 1.785 6.6 4.497 8.412a10.07 10.07 0 01-4.578-1.264l-.001.128c0 4.896 3.484 8.98 8.108 9.91a10.143 10.143 0 01-4.565.173c1.287 4.015 5.019 6.937 9.44 7.019A20.277 20.277 0 017.23 46.446c-.816 0-1.62-.048-2.411-.14a28.606 28.606 0 0015.493 4.54c18.59 0 28.756-15.4 28.756-28.757 0-.437-.009-.874-.028-1.307a20.518 20.518 0 005.042-5.232z",
      stroke: "none"
    })]
  });
};
const IconTwitter = /*#__PURE__*/styled(SvgComponent).withConfig({
  displayName: "Twitter__IconTwitter",
  componentId: "sc-lsrxtv-0"
})(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: inline-flex;\n  vertical-align: middle;\n"])));

export { IconTwitter };
